// --------------------------------------------------------------
// Created On: 2021-09-30
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import validateNickname from "../../../utilities/validateNickname";

// A single asset in an asset list.
export default function AssetListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="asset-list-row">
      {props.name} {validateNickname(props.nickname, props.name) ? `(${props.nickname})` : ""}
    </div>
  );
}

interface Props {
  assetId: number;
  name: string;
  nickname: string;
}
